<script>
  import { defineComponent } from 'vue'
  const name = 'Contador'

  export default defineComponent({
    name,

    components: {},

    props: {
      quantidadePagina: {
        type: Number,
        required: true
      },
      totalRegistros: {
        type: Number,
        required: true
      }
    },

    mounted() {},

    updated() {},

    data() {
      return {}
    },

    methods: {},

    computed: {},
  })
</script>

<template>
  <div class="contador"> Mostrando <div class="font-bold">{{ quantidadePagina }}</div> de <div class="font-bold">{{ totalRegistros }}</div> </div>
</template>

<style scoped>
.contador {
  font-family: "MontSerrat";
  display: flex;
  gap: 0.25rem;
}
</style>
